/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SubmissionsAnalyticsDataParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('submission')],
    ['userId', codecNumber, 'user_id'],
    ['createdAt', parsers.moment, 'created_at'],
    ['grade', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
    ['assigneeId', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'assignee_id'],
]);
export class SubmissionsAnalyticsData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SubmissionsAnalyticsDataParser.decode(input).map(res => new SubmissionsAnalyticsData(res));
    }
    static unsafeDecode(input) {
        return SubmissionsAnalyticsData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SubmissionsAnalyticsDataParser.encode(data);
    }
    static schema() {
        return SubmissionsAnalyticsDataParser.schema();
    }
}
